module.exports = __webpack_public_path__ + "img/jellyfish_jelly.33a9b820.jpg";